import { FC } from "react";
import NavLink from "next/link";
import { addDaysToDate } from "../../../../utils";
import { ShippinProfile } from "../../../../types/product_entity_types";
import DeliveryCounter from "./DeliveryCounter/DeliveryCounter";
import { useLocaleContext } from "../../../context/LocaleContext/LocaleContext";
import { List, ListItem, ListItemText, Typography, Link } from "@mui/material";

interface Props {
  shippingProfile: ShippinProfile;
}

export const DeliveryInformation: FC<Props> = ({ shippingProfile }) => {
  const { currency } = useLocaleContext();

  const minHandlingTime =
    currency === "INR"
      ? shippingProfile.minHandlingTime
      : shippingProfile.internationalShipping.minHandlingTime;
  const maxHandlingTime =
    currency === "INR"
      ? shippingProfile.maxHandlingTime
      : shippingProfile.internationalShipping.maxHandlingTime;

  return (
    <List dense disablePadding sx={{ listStyleType: "circle" }}>
      <ListItem disableGutters sx={{ display: "list-item", ml: 2 }}>
        <ListItemText
          primary={
            <>
              Order within{" "}
              <span className="text-red-700 dark:text-red-300">
                <DeliveryCounter />
              </span>{" "}
              and get the item delivered by,
            </>
          }
          secondary={
            <>
              {addDaysToDate(minHandlingTime)} -{" "}
              {addDaysToDate(maxHandlingTime)}
            </>
          }
          secondaryTypographyProps={{
            fontWeight: 600,
            color: "black",
            mt: 0.5,
          }}
        />
      </ListItem>
      <ListItem disableGutters sx={{ display: "list-item", ml: 2 }}>
        <ListItemText
          primary={
            currency === "INR"
              ? "Hassle-Free Returns within 7 days of delivery (*T&C Apply)."
              : "Return is not available outside India. (*T&C Apply)."
          }
          secondary={
            <>
              For more details visit{" "}
              <Link
                underline="hover"
                component={NavLink}
                href={
                  currency === "INR"
                    ? "/policies/returns-refunds-cancellations"
                    : "/policies/international-shipping"
                }>
                {currency === "INR"
                  ? "Returns Policy"
                  : "International Shipping Policy"}
              </Link>
            </>
          }
          secondaryTypographyProps={{
            fontWeight: 600,
            color: "black",
            mt: 0.5,
          }}
        />
      </ListItem>
    </List>
  );
};
